import { useNavigate, useParams } from 'react-router-dom';
import {
  useDeleteEventMutation,
  useGetEventQuery,
  useUpdateEventMutation,
} from './events.api';
import { Formik } from 'formik';
import { EventForm } from './event-form';
import { toast } from 'react-toastify';
import { PageTitle } from 'shared-components';
import Routes from '../../app/routes';

export const Event = () => {
  const { id } = useParams<{ id: string }>();
  const { data, isLoading } = useGetEventQuery(id as string);
  const [update] = useUpdateEventMutation();
  const navigate = useNavigate();
  const [deleteEvent] = useDeleteEventMutation();

  if (isLoading) {
    return <span>loading...</span>;
  }

  return (
    <Formik
      initialValues={{
        name: data?.name ?? '',
        date: new Date(data?.date ?? new Date()).toISOString().split('T')[0],
        requiresPassword: data?.requiresPassword ?? false,
        password: data?.password ?? '',
        pricingOverrides: data?.pricingOverrides ?? [],
        enabledProducts: data?.enabledProducts ?? [],
      }}
      enableReinitialize={true}
      onSubmit={async (values) => {
        await update({
          id: id as string,
          data: {
            ...values,
            date: new Date(values.date),
          },
        });
        toast.success('Event updated!', {
          autoClose: 2000,
        });
      }}
    >
      {({ submitForm }) => (
        <>
          <PageTitle
            title="Event"
            crumbs={[
              { display: Routes.DASHBOARD.title, link: Routes.DASHBOARD.link },
              { display: Routes.EVENTS.title, link: Routes.EVENTS.link },
              {
                display: data?.name ?? '',
                link: Routes.EVENT.createLink?.(id as string) ?? '',
              },
            ]}
            allowDelete={true}
            allowSave={true}
            onAction={async (action) => {
              switch (action) {
                case 'save':
                  submitForm();
                  break;
                case 'delete':
                  // eslint-disable-next-line no-restricted-globals
                  if (confirm('Are you sure you want to delete this event?')) {
                    await deleteEvent(id as string);
                    navigate(Routes.EVENTS.link);
                    toast.success('Event deleted!');
                  }
                  break;
              }
            }}
          />
          <EventForm />
        </>
      )}
    </Formik>
  );
};
